import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 dark:bg-black text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">R</span>
              </div>
              <span className="text-lg font-bold">RaffleBowl</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Fair, transparent split-the-pot raffles with instant payouts. Your next win is just a ticket away.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/raffles" className="text-gray-300 hover:text-white transition-colors">Browse Raffles</Link></li>
              <li><Link to="/draw-history" className="text-gray-300 hover:text-white transition-colors">Draw History</Link></li>
              <li><Link to="/dashboard" className="text-gray-300 hover:text-white transition-colors">My Account</Link></li>
              <li><Link to="/agent/apply" className="text-gray-300 hover:text-white transition-colors">Become an Agent</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">Support</h4>
            <ul className="space-y-3 text-sm">
              <li><button className="text-gray-300 hover:text-white transition-colors text-left">Help Center</button></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact Us</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/terms" className="text-gray-300 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} RaffleBowl. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
